/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Agents_LabelInputs */

const en_common_header_ai_agents_label = /** @type {(inputs: Common_Header_Ai_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For AI Agents`)
};

const zh_common_header_ai_agents_label = /** @type {(inputs: Common_Header_Ai_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面向 AI Agent`)
};

/**
* | output |
* | --- |
* | "For AI Agents" |
*
* @param {Common_Header_Ai_Agents_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_agents_label = /** @type {((inputs?: Common_Header_Ai_Agents_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Agents_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_agents_label(inputs)
	return zh_common_header_ai_agents_label(inputs)
});
export { common_header_ai_agents_label as "common.header.ai.agents.label" }